import { normalizeWorkspace } from 'lib/analytics'

export function workspaceUpdated (workspace) {
  window.analytics.track('Settings Workspace Information Edited', normalizeWorkspace(workspace))
}



// WEBPACK FOOTER //
// ./analytics/workspaces.js